import React from 'react';
import { Input } from 'antd';
import { classNames } from 'utils';
import './textarea.scss';

const { TextArea: AntTextArea } = Input;

const TextArea = ({ ...rest }) => {
  return <AntTextArea className={classNames('ui-kit-textarea')} {...rest} />;
};

export default TextArea;
